/* eslint-disable no-useless-catch */
import { entityService } from './services';

const pathname = '/standard-steps';

export const StandardStepApi = {
  find: async (id: string) => {
    const url = `${pathname}/standardProcess/${id}`;
    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};
